/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Port } from './Port';
import {
    PortFromJSON,
    PortFromJSONTyped,
    PortToJSON,
    PortToJSONTyped,
} from './Port';

/**
 * 
 * @export
 * @interface PaginatedPortList
 */
export interface PaginatedPortList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedPortList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedPortList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedPortList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<Port>}
     * @memberof PaginatedPortList
     */
    results: Array<Port>;
}

/**
 * Check if a given object implements the PaginatedPortList interface.
 */
export function instanceOfPaginatedPortList(value: object): value is PaginatedPortList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function PaginatedPortListFromJSON(json: any): PaginatedPortList {
    return PaginatedPortListFromJSONTyped(json, false);
}

export function PaginatedPortListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedPortList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(PortFromJSON)),
    };
}

  export function PaginatedPortListToJSON(json: any): PaginatedPortList {
      return PaginatedPortListToJSONTyped(json, false);
  }

  export function PaginatedPortListToJSONTyped(value?: PaginatedPortList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(PortToJSON)),
    };
}

